export default __webpack_public_path__ + "static/media/gallery_12.87c1ce48.jpg";